"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m14.76 2.108 7.174 4.075-8.666 15.723-11.202-6.361L8.452 3.941c.11-.196.442-.454.624-.507h.001L14 2.022l.005-.001c.192-.056.6-.003.746.081l.008.005v.001ZM.91 17.188l11.59 6.58a1.732 1.732 0 0 0 1.758-.018 1.77 1.77 0 0 0 .65-.674l8.867-16.089a1.81 1.81 0 0 0 .157-1.366 1.766 1.766 0 0 0-.84-1.08L15.747.369C15.12.009 14.15-.102 13.45.1L8.52 1.513c-.7.203-1.458.812-1.818 1.459L.225 14.74a1.813 1.813 0 0 0 .683 2.446l.001.002Zm9.943-11.032c.143.038.28.094.41.166l5.02 2.853c.414.23.71.618.84 1.08.128.461.072.95-.158 1.366l-3.46 6.277c-.23.415-.61.72-1.062.85a1.785 1.785 0 0 1-1.347-.166l-5.02-2.853a1.766 1.766 0 0 1-.84-1.08 1.81 1.81 0 0 1 .157-1.367l2.522-4.574.94-1.702a1.77 1.77 0 0 1 1.03-.84l.027-.009h.003v.009l.002-.001.032-.009a1.76 1.76 0 0 1 .904 0Zm-3.62 7.93 3.255-5.903 4.636 2.634-3.254 5.903-4.636-2.634Z",
    clipRule: "evenodd"
  })]
});